import { Component } from 'react';

import { GLOBAL } from 'saddlebag-browser';

export class ScrollToTop extends Component<{}> {
  componentDidMount() {
    const $window = GLOBAL.getWindow();
    $window.scrollTo(0, 0);
  }

  render(): null {
    return null;
  }
}
